import { useSelector } from 'react-redux';

export const useTemporaryStorage = () =>
    useSelector((state) => state?.user?.temporaryStorage) || { inject: false };
